export default __webpack_public_path__ + "static/media/017-opera.928d94fb.svg";